import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { classNames } from '../../utils';
import { i18n } from '../../language';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  tabHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    '& :last-child': {
      marginRight: '0',
    },
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '2.25rem',
    fontWeight: 'bold',
    marginBottom: '3.438rem',
  },
  tabButton: ({ tabWidth }) => ({
    width: tabWidth ?? '10rem',
    height: '3.875rem',
    backgroundColor: '#538fff11',
    borderRadius: '0.75rem 0.75rem 0 0',
    textTransform: 'capitalize',
    position: 'relative',
    marginRight: '0.625rem',
    '&:hover': {
      background: '#538fff11',
    },
    '& .MuiButton-label': {
      fontFamily: 'NotoSans-Bold',
      whiteSpace: 'nowrap',
      fontSize: '1rem',
      fontWeight: '600',
      textAlign: 'center',
      color: '#538fff',
      opacity: 0.6,
    },
  }),
  selectBtn: {
    opacity: 1,
    backgroundColor: '#fff !important',
    fontWeight: 'bold',
    '& .MuiButton-label': {
      opacity: '1 !important',
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    '&:hover': {
      background: '#fff',
    },
  },
}));

const TabView = ({
  tabList,
  value,
  className,
  OtherButton,
  tabWidth,
  selectedClassName,
  unSelectedClassName,
  tabBoxClassName,
  setLeaveOpen,
  setContinueFunc,
}) => {
  const classes = useStyles({ tabWidth });
  const [tabValue, setTabValue] = useState(value ?? tabList[0].value);
  const editFlag = useSelector((state) => state.dutyEditFlag);

  useEffect(() => {
    if (value) {
      setTabValue(value);
    }
  }, [value]);

  const tabOnClick = useCallback(
    (props) => () => {
      if (editFlag) {
        setLeaveOpen(true);
        setContinueFunc(() => () => setTabValue(props));
      } else {
        setTabValue(props);
      }
    },
    [setTabValue, editFlag]
  );

  const Data = useMemo(() => {
    return {
      Component: _.find(tabList, (item) => item.value === tabValue).component,
      props: _.find(tabList, (item) => item.value === tabValue).props,
    };
  }, [tabList, tabValue]);

  const tabClassName = useCallback(
    (props) => {
      if (selectedClassName && unSelectedClassName) {
        return props === tabValue ? selectedClassName : unSelectedClassName;
      } else {
        return props === tabValue ? classNames(classes.tabButton, classes.selectBtn) : classes.tabButton;
      }
    },
    [tabValue, selectedClassName, unSelectedClassName]
  );

  return (
    <div className={className ? classNames(className, classes.root) : classes.root}>
      <div className={classes.tabHeader}>
        <Box display="flex" gridGap="1.25rem" className={tabBoxClassName}>
          {tabList.map((item) => (
            <ButtonBase
              id={item.testID}
              key={item.testID}
              className={tabClassName(item.value)}
              onClick={tabOnClick(item.value)}
            >
              {i18n.t(item.title)}
            </ButtonBase>
          ))}
        </Box>
        {OtherButton && <OtherButton />}
      </div>
      <Data.Component {...Data.props} />
    </div>
  );
};

export default TabView;
